import { render, staticRenderFns } from "./Immerse.vue?vue&type=template&id=3ff210f7&"
import script from "./Immerse.vue?vue&type=script&lang=js&"
export * from "./Immerse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports